import {DatePipe} from '@angular/common';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {environment} from '@env/environment';
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import {AuthTokenService} from './auth-token.service';

@Injectable()
export class ApiService {
    deleteClientRegistrationAuthorizedPerson(clientRegistrationId: any, id: any) {
        throw new Error("Method not implemented.");
    }

    private serviceControllerVersion = "v2";

    constructor(private httpClient: HttpClient,
                public authToken: AuthTokenService) {
    }

    public fetch(url): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded"
            })
        };

        return this.httpClient.get(environment.URL + url, httpOptions).pipe(
            map((data: any) => data.data || data),
            catchError(this.handleError)
        );
    }

    public fetchBase(url): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded"
            })
        };
        return this.httpClient.get(environment.BASE_URL + url, httpOptions).pipe(
            map((data: any) => data.data || data),
            catchError(this.handleError)
        );
    }

    public putForm(url, body): Observable<any> {
        return this.httpClient.put(environment.URL + url, body).pipe(
            map((data: any) => data.data || data),
            catchError(this.handleError)
        );
    }

    public putJson(url, body): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.httpClient.put(environment.URL + url, body.toString(), httpOptions)
            .pipe(
                map((data: any) => (data.data || data)),
                catchError(this.handleError)
            )
    }

    private delete(url, body): Observable<any> {
        // const httpOptions = {
        //     headers: new HttpHeaders({
        //         'Content-Type': 'application/x-www-form-urlencoded'
        //     })
        // };
        return this.httpClient.delete(environment.URL + url, body).pipe(
            map((data: any) => data.data || data),
            catchError(this.handleError)
        );
    }

    public patchForm(url, body): Observable<any> {
        return this.httpClient.patch(environment.URL + url, body).pipe(
            map((data: any) => data.data || data),
            catchError(this.handleError)
        );
    }

    public post(url, body): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };
        return this.httpClient.post(environment.URL + url, body.toString(), httpOptions)
            .pipe(
                map((data: any) => (data.data || data)),
                catchError(this.handleError)
            )
    }

    public postBase(url, body): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
                // 'Access-Control-Allow-Origin': '*'
            })
        };
        return this.httpClient
            .post(environment.BASE_URL + url, body.toString(), httpOptions)
            .pipe(
                map((data: any) => data.data || data),
                catchError(this.handleError)
            );
    }

    public postForm(url, body): Observable<any> {
        return this.httpClient.post(environment.URL + url, body).pipe(
            map((data: any) => data.data || data),
            catchError(this.handleError)
        );
    }

    public postJson(url, body): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.httpClient.post(environment.URL + url, body.toString(), httpOptions)
            .pipe(
                map((data: any) => (data.data || data)),
                catchError(this.handleError)
            )
    }

    public patchJson(url, body): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.httpClient.patch(environment.URL + url, body.toString(), httpOptions)
            .pipe(
                map((data: any) => (data.data || data)),
                catchError(this.handleError)
            )
    }

    //TODO: Dummy url below has been added to avoid errors on console.  It will be good idea if we find a way to pass IDs to update or delete grid rows.
    /**
     * @params key: id
     * @params method: GET/POST/PUT/DELETE
     * @params endpoint: controllerName/endpoint
     * @params body: pass an object with parameters or null
     * @returns Retrieve data in customStore using Paging.  The amount of data that this method is going to take and skip from the database defines in template file.
     */
    public getAspNetDataStore(key: any, method: string, endpoint: string, body: any) {
        return AspNetData.createStore({
            key: key,
            loadMethod: method,
            loadUrl: body != null ? `${environment.URL}/${endpoint}?customFilters=` + JSON.stringify(body) : `${environment.URL}/${endpoint}`,
            deleteUrl: `${environment.URL}/paging/devExtremeDummyUrl`,
            updateUrl: `${environment.URL}/paging/devExtremeDummyUrl`,
            onBeforeSend: (_, httpOptions) => {
                httpOptions.headers = {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": `Bearer ${this.authToken.token}`
                }
                // If condition prevents disabling the search button while filtering with clients dropdown.
                if (endpoint != 'reportFilters/filter' && endpoint != 'paging/filter' && endpoint != 'paging/criteriaFilter') {
                    // Disable button while loading the data
                    $('button:contains("Search")').addClass('disabled').prop("disabled", true);
                    $('button:contains("Reload")').addClass('disabled').prop("disabled", true);
                }
            },
            onLoaded: function (_) {
                // Enable button when data have loaded
                $('button:contains("Search")').removeClass('disabled').prop("disabled", false);
                $('button:contains("Reload")').removeClass('disabled').prop("disabled", false);
            },
            errorHandler: function (_) {
                $('button:contains("Search")').removeClass('disabled').prop("disabled", false);
                $('button:contains("Reload")').removeClass('disabled').prop("disabled", false);
            }
        });
    }

    public getUser(): Observable<any> {
        return this.fetch("/user/getUser");
    }

    public getUserByEMail(email: string): Observable<any> {
        return this.fetch("/administration/getUserByEmail/" + email);
    }

    public resetClientSecret(id: string, secret: string): Observable<any> {
        let body = {
            "clientId": id,
            "clientSecret": secret
        }
        return this.postJson("/administration/resetClientSecret", JSON.stringify(body));
    }

    public getNotifications(): Observable<any> {
        return this.fetch("/user/getNotifications");
    }

    public updateNotificationIsRead(id: any): Observable<any> {
        let body = {
            "id": id
        }

        return this.patchJson("/administration/updateNotificationIsRead", JSON.stringify(body));
    }

    public updateAllNotificationsIsRead(isRead: boolean): Observable<any> {
        let body = {
            "isRead": isRead
        }
        return this.patchJson("/administration/updateAllNotificationsIsRead", JSON.stringify(body));
    }

    public getUsers(): Observable<any> {
        return this.fetch("/administration/getUsers");
    }

    public getUsersByAccountId(accountId: number): Observable<any> {
        return this.fetch(`/administration/Users/${accountId}`);
    }

    public getAcurisMonitoringLists(): Observable<any> {

        return this.fetch("/administration/getAcurisMonitoringLists");
    }

    public getAccountServicesExpiration(form: FormGroup): Observable<any> {
        let body = {
            "AccountId": form.controls.accountId.value,
            "ServiceType": form.controls.serviceType.value,
            "ExpirationDate": form.controls.expirationDate.value,
            "ValidServices": form.controls.validServices.value,
            "ExpiredServices": form.controls.expiredServices.value
        };

        return this.postJson("/administration/getAccountServicesExpiration", JSON.stringify(body));
    }

    public getAcurisOngoingMonitoringBundleLists(): Observable<any> {

        return this.fetch("/administration/getAcurisOngoingMonitoringBundle");
    }

    public getSimpleAccountsDetails(): Observable<any> {
        return this.fetch("/administration/accounts/simple");
    }

    public getAccountsDetails(): Observable<any> {
        return this.fetch("/administration/getAccountsDetails");
    }

    public getAccountDetailsById(accountId: number): Observable<any> {
        return this.fetch(`/administration/account/${accountId}`);
    }

    public getServiceLicenses(): Observable<any> {
        return this.fetch("/administration/serviceLicenses");
    }

    public getServiceLicenseById(serviceLicenseId: any): Observable<any> {
        return this.fetch("/administration/serviceLicenses/" + serviceLicenseId.toString());
    }

    public getServices(): Observable<any> {
        return this.fetch("/administration/services");
    }

    public getServicesNames(): Observable<any> {
        return this.fetch("/administration/serviceNames");
    }

    public getAppVersion(): Observable<any> {

        return this.fetch("/user/getAppVersion");
    }


    public getNotificationTypes(): Observable<any> {

        return this.fetch("/administration/getNotificationTypes");
    }

    public getAccountLogo(): Observable<any> {

        return this.fetch("/user/accountLogo");
    }

    public getGuestAccountLogo(): Observable<any> {

        return this.fetch("/guest/accountLogo");
    }


    public getIconTypes(): Observable<any> {

        return this.fetch("/administration/getIconTypes");
    }

    public getValidServices(): Observable<any> {

        return this.fetch("/user/getValidServices");
    }


    public getRoles(): Observable<any> {

        return this.fetch("/administration/getRoles");
    }

    public getServiceTypes(): Observable<any> {
        return this.fetch("/administration/getServiceTypes");
    }

    public getAcurisWorklists(): Observable<any> {

        return this.fetch("/administration/acurisV3/worklists");
    }

    public getServiceLicensesList(): Observable<any> {
        return this.fetch("/administration/getServiceLicensesList");
    }


    public getDashboard(): Observable<any> {
        return this.fetch("/user/getDashboard");
    }

    public getCountries(): Observable<any> {
        return this.fetch("/v3/service/getCountries");
    }

    public getPersonSearchThreshold(actionName: string, serviceTypeName: string): Observable<any> {
        return this.fetch(`/v3/service/personSearchThreshold/${actionName}/${serviceTypeName}`);
    }

    public getIdentityVerificationCountries(): Observable<any> {
        return this.fetch("/v3/service/getIdentityVerificationCountries");
    }


    //Accounts Transactions for Administration
    public GetAccountsTransactionsPerAccount(accountId: any): Observable<any> {
        return this.fetch("/administration/" + accountId + "/getAccountsTransactionsPerAccount");
    }

    //Accounts Restricted Countries for Administration
    public getAccountsRestrictedCountriesPerAccount(accountId: any): Observable<any> {
        return this.fetch("/administration/" + accountId + "/getAccountsRestrictedCountriesPerAccount");
    }

    //Accounts Services for Administration
    public getAccountsServices(): Observable<any> {
        return this.fetch("/administration/getAccountsServices");
    }

    public toggleAccountRestrictedCountry(accountId: number, countryId: number): Observable<any> {
        let body = {
            "accountId": accountId,
            "countryId": countryId,
        };
        return this.postJson(`/administration/toggleAccountRestrictedCountry/${accountId}/countries/${countryId}`, JSON.stringify(body));
    }


    public getEGOVLogo(domainName: string): Observable<any> {
        let body = {
            "ClientdomainName": domainName

        };
        return this.postJson(`/guest/EGOVLogo/`, JSON.stringify(body));
    }


    //Accounts Transactions for Administration
    public getAccountsTransactions(transactionsSearchForm: FormGroup): Observable<any> {
        let body = {
            "StartDate": transactionsSearchForm.controls.startDate.value,
            "EndDate": transactionsSearchForm.controls.endDate.value,
            "AccountId": transactionsSearchForm.controls.accountId.value,
            "Service": transactionsSearchForm.controls.service.value,
            "ServiceType": transactionsSearchForm.controls.serviceType.value,
        };
        return this.postJson("/administration/getAccountsTransactions", JSON.stringify(body));
    }

    //Account Transactions for User/Client
    public getAccountTransaction(transactionsSearchForm: FormGroup): Observable<any> {

        let body = {
            "StartDate": transactionsSearchForm.controls.startDate.value,
            "EndDate": transactionsSearchForm.controls.endDate.value,
        };

        return this.postJson("/user/getAccountTransactions", JSON.stringify(body));
    }


    public getAccountsTransactionsIdVer(transactionsSearchForm: FormGroup): Observable<any> {
        let body = {
            "AccountId": transactionsSearchForm.controls.accountId.value,
            "StartDate": transactionsSearchForm.controls.startDate.value,
            "EndDate": transactionsSearchForm.controls.endDate.value,
        };
        return this.postJson("/administration/getAccountsTransactionsIdVer", JSON.stringify(body));
    }


    public getAdHocServiceCost(action: string, vatCountry: string): Observable<any> {
        let body = {
            "code": "123456",
            "action": action,
            "vatCountry": vatCountry
        }
        return this.postJson("/guest/getAdHocServiceCost", JSON.stringify(body));
    }

    public createContainer(containerName: string): Observable<any> {
        let body = {
            "containerName": containerName
        }
        return this.postJson("/administration/createContainer", JSON.stringify(body));
    }

    public deleteContainer(containerName: string): Observable<any> {
        let body = {
            "containerName": containerName
        };
        return this.delete("/administration/deleteContainer", JSON.stringify(body));
    }

    public saveAndSendMrzCheck(mrzCheckModel: any): Observable<any> {
        let body = {
            "reportModelString": mrzCheckModel.reportModelString,
            "reportModel": mrzCheckModel.reportModel,
            "uploadModel": mrzCheckModel.uploadModel,
        };
        return this.postJson("/v3/service/saveAndSendMrzCheck", JSON.stringify(body));
    }

    public saveAndSendDocumentCheck(fullAuthenticityCheckModel: any): Observable<any> {
        let body = {
            "reportModelString": fullAuthenticityCheckModel.reportModelString,
            "reportModel": fullAuthenticityCheckModel.reportModel,
            "uploadModel": fullAuthenticityCheckModel.uploadModel,
        };
        return this.postJson("/v3/service/saveAndSendDocumentCheck", JSON.stringify(body));
    }

    public saveAndSendIdentityCheck(IdentityCheckModel: any): Observable<any> {
        let body = {
            "reportModelString": IdentityCheckModel.reportModelString,
            "reportModel": IdentityCheckModel.reportModel,
            "uploadModel": IdentityCheckModel.uploadModel,
        };
        return this.postJson("/v3/service/saveAndSendIdentityCheck", JSON.stringify(body));
    }

    public getIdVerificationDataSupports(): Observable<any> {
        return this.fetch("/v3/service/idVerificationDataSupports");
    }

    public getIdentityVerificationTenantTypes(): Observable<any> {
        return this.fetch("/administration/identityVerificationTenantTypes");
    }

    public getSocialMediaAlerts(): Observable<any> {
        return this.fetch("/v3/service/socialmedia/alerts");
    }

    public getSocialMediaCelebrities(): Observable<any> {
        return this.fetch("/v3/service/socialmedia/celebrities");
    }

    public getSocialMediaEncodedImage(id: string): Observable<any> {
        return this.fetch(`/v3/service/socialmedia/image/encoded/${id}`);
    }

    public downloadBlob(containerName: string, fileName: string): Observable<any> {
        let body = {
            "containerName": containerName,
            "fileName": fileName
        }
        return this.postJson("/v3/service/downloadBlob", JSON.stringify(body));
    }

    public uploadBlob(containerName: string, localPath: string, fileName: string, fileToUploadBase64Data: string): Observable<any> {
        let body = new URLSearchParams();
        body.set("containerName", containerName);
        body.set("localPath", localPath);
        body.set("fileName", fileName);
        body.set("fileToUploadBase64Data", fileToUploadBase64Data);
        return this.post("/v3/service/uploadBlob", body);
    }

    public deleteBlob(containerName: string, localPath: string, fileName: string): Observable<any> {
        let body = {
            "containerName": containerName,
            "localPath": localPath,
            "fileName": fileName,
        }
        return this.delete("/v3/service/deleteBlob", JSON.stringify(body));
    }

    public personSearch(personSearchForm: FormGroup, serviceName: string): Observable<any> {

        var body;
        if (serviceName == "Acuris") {
            let acurisBody = {
                "fullName": personSearchForm.controls.fullName.value,
                "dateOfBirth": personSearchForm.controls.dateOfBirth.value,
                "address": personSearchForm.controls.address.value,
                "city": personSearchForm.controls.city.value,
                "postcode": personSearchForm.controls.postCode.value,
                "country": personSearchForm.controls.country.value,
                "threshold": personSearchForm.controls.threshold.value
            }

            body = {
                "acuris": acurisBody
            }
        } else if (serviceName === "ScreenTek") {
            body = {
                iSpiralAcurisLists: {
                    "fullName": personSearchForm.controls.fullName.value,
                    firstName: "",
                    lastName: personSearchForm.controls.fullName.value,
                    "dateOfBirth": personSearchForm.controls.dateOfBirth.value, // not used in iSpiralAcurisLists
                    "address": personSearchForm.controls.address.value, // not used in iSpiralAcurisLists
                    "city": personSearchForm.controls.city.value,// not used in iSpiralAcurisLists
                    "postcode": personSearchForm.controls.postCode.value,// not used in iSpiralAcurisLists
                    "country": personSearchForm.controls.country.value,// not used in iSpiralAcurisLists
                    "threshold": personSearchForm.controls.threshold.value
                }
            }
        } 
        else if (serviceName == "Bridger") {
            let bridgerBody = {
                "firstName": personSearchForm.controls.firstName.value,
                "middlename": personSearchForm.controls.middleName.value,
                "lastName": personSearchForm.controls.lastName.value,
                "dateOfBirth": personSearchForm.controls.dateOfBirth.value,
                "addressLine1": personSearchForm.controls.addressLine1.value,
                "addressLine2": personSearchForm.controls.addressLine2.value,
                "city": personSearchForm.controls.city.value,
                "postalCode": personSearchForm.controls.postalCode.value,
                "country": personSearchForm.controls.country.value,
                "iDNumber": personSearchForm.controls.iDNumber.value,
                "gender": personSearchForm.controls.gender.value != "" ? personSearchForm.controls.gender.value : null,
                "threshold": personSearchForm.controls.threshold.value
            }
            body = {
                "bridger": bridgerBody
            }
        } else if (serviceName == "WorldCheck") {
            let worldCheckBody = {
                "name": personSearchForm.controls.name.value,
                "DateOfBirth": personSearchForm.controls.dateOfBirth.value,
                "countryLocation": personSearchForm.controls.countryLocation.value,
                "countryOfBirth": personSearchForm.controls.countryOfBirth.value,
                "countryNationality": personSearchForm.controls.countryNationality.value,
                "gender": personSearchForm.controls.gender.value != "" ? personSearchForm.controls.gender.value : null,
                "threshold": personSearchForm.controls.threshold.value
            }
            body = {
                "worldCheck": worldCheckBody
            }
        } else if (serviceName == "Rdc") {
            let rdcBody = {
                "name": personSearchForm.controls.name.value,
                "dateOfBirth": personSearchForm.controls.dateOfBirth.value,
                "address": personSearchForm.controls.address.value,
                "city": personSearchForm.controls.city.value,
                "postcode": personSearchForm.controls.postCode.value,
                "stateProv": personSearchForm.controls.stateProv.value,
                "country": personSearchForm.controls.country.value,
                "threshold": personSearchForm.controls.threshold.value,
                "Monitoring": false
            }
            body = {
                "rdc": rdcBody
            }
        }
        return this.postJson("/v3/service/personSearch", JSON.stringify(body));
    }

    public personSearchProfile(profileId, serviceName: string): Observable<any> {

        var body;
        if (serviceName == "Acuris") {

            body = {
                "acurisResourceId": profileId
            }
        } else if (serviceName == "WorldCheck") {
            body = {
                "worldCheckReferenceId": profileId
            }
        }


        return this.postJson("/v3/service/personSearchProfile", JSON.stringify(body));
    }

    public businessSearchProfile(profileId, serviceName: string): Observable<any> {

        var body;
        if (serviceName == "Acuris") {

            body = {
                "acurisResourceId": profileId
            }
        } else if (serviceName == "WorldCheck") {
            body = {
                "worldCheckReferenceId": profileId
            }
        }

        return this.postJson("/v3/service/businessSearchProfile", JSON.stringify(body));
    }

    public adHocPersonSearch(personSearchForm: FormGroup): Observable<any> {
        let body = {
            "fullName": personSearchForm.controls.fullName.value,
            "DateOfBirth": personSearchForm.controls.dateOfBirth.value,
            "Address": personSearchForm.controls.address.value,
            "City": personSearchForm.controls.city.value,
            "Postcode": personSearchForm.controls.postCode.value,
            "Country": personSearchForm.controls.country.value
        }
        return this.postJson("/v3/service/personSearch", JSON.stringify(body));
    }

    public getResetPasswordToken(forgotPasswordForm: FormGroup): Observable<any> {
        let body = new URLSearchParams();
        body.set("Email", forgotPasswordForm.controls.email.value);
        return this.postBase("/authorization/getResetPasswordToken", body);
    }

    public resetPassword(resetPasswordForm: FormGroup, email: string, token: string): Observable<any> {
        let body = new URLSearchParams();
        body.set("Email", email);
        body.set("Token", token);
        body.set("NewPassword", resetPasswordForm.controls.newPassword.value);
        body.set("ConfirmPassword", resetPasswordForm.controls.confirmPassword.value);
        return this.postBase("/authorization/resetPassword", body);
    }

    public personSearchReport(personSearchResult: any): Observable<any> {
        return this.post('/redirect/personSearchReport', personSearchResult);
    }

    public businessSearch(businessSearchForm: FormGroup, serviceName: string): Observable<any> {
        var body;

        if (serviceName == "Acuris") {
            let acurisBody = {
                "BusinessName": businessSearchForm.controls.businessName.value,
                "Address": businessSearchForm.controls.address.value,
                "City": businessSearchForm.controls.city.value,
                "Postcode": businessSearchForm.controls.postCode.value,
                "Country": businessSearchForm.controls.country.value,
                "Threshold": businessSearchForm.controls.threshold.value,
            }
            body = {
                "acuris": acurisBody
            }
        } else if (serviceName === 'ScreenTek'){
            body = {
                iSpiralAcurisLists: {
                    BusinessName: businessSearchForm.controls.businessName.value,
                    Threshold: businessSearchForm.controls.threshold.value,
                }
            }
        } 
        else if (serviceName == "Bridger") {
            let bridgerBody = {
                "businessName": businessSearchForm.controls.businessName.value,
                "addressLine1": businessSearchForm.controls.addressLine1.value,
                "addressLine2": businessSearchForm.controls.addressLine2.value,
                "city": businessSearchForm.controls.city.value,
                "postalCode": businessSearchForm.controls.postalCode.value,
                "country": businessSearchForm.controls.country.value,
                "iDNumber": businessSearchForm.controls.iDNumber.value,
                "Threshold": businessSearchForm.controls.threshold.value,
            }
            body = {
                "bridger": bridgerBody
            }
        } else if (serviceName == "WorldCheck") {
            let worldCheckBody = {
                "BusinessName": businessSearchForm.controls.businessName.value,
                "RegisteredCountry": businessSearchForm.controls.registeredCountry.value,
                "Threshold": businessSearchForm.controls.threshold.value,
            }
            body = {
                "worldCheck": worldCheckBody
            }
        } else if (serviceName == "Rdc") {
            let rdcBody = {
                "BusinessName": businessSearchForm.controls.businessName.value,
                "Address": businessSearchForm.controls.address.value,
                "City": businessSearchForm.controls.city.value,
                "Postcode": businessSearchForm.controls.postCode.value,
                "Country": businessSearchForm.controls.country.value,
                "Threshold": businessSearchForm.controls.threshold.value,
                "Monitoring": false
            }
            body = {
                "rdc": rdcBody
            }
        }

        return this.postJson("/v3/service/businessSearch", JSON.stringify(body));
    }

    public createAccount(createAccountForm: FormGroup): Observable<any> {
        let body = {
            "Name": createAccountForm.controls.accountName.value,
            "DisplayName": createAccountForm.controls.displayName.value,
            "ContactName": createAccountForm.controls.contactName.value,
            "ContactPhone": createAccountForm.controls.contactPhone.value,
            "ContactEmail": createAccountForm.controls.contactEmail.value,
            "SendEmailNotification": createAccountForm.controls.sendEmailNotification.value,
            "NearDaysExpiration": createAccountForm.controls.daysBeforeExpiration.value ? createAccountForm.controls.daysBeforeExpiration.value : 10,
            "NearTokenDepletionPercentage": createAccountForm.controls.tokensThresholdPercentage.value ? createAccountForm.controls.tokensThresholdPercentage.value : 10,
        }

        return this.postJson("/administration/createAccount", JSON.stringify(body));
    }

    public getOrganizationAccount(): Observable<any> {
        return this.fetch("/administration/organizationAccount");
    }


    public getHealthCheckIndicator(): Observable<any> {
        return this.fetch("/healthcheck/healthcheckindicator");
    }

    public getGuestOrganizationAccount(): Observable<any> {
        return this.fetch("/guest/organizationAccount");
    }

    public getHealthCheckDashboard(): Observable<any> {
        return this.fetch("/healthcheck/healthcheckdashboard");
    }

    public performHealthCheck(): Observable<any> {
        const body = {};

        return this.postJson("/healthcheck/performHealthCheck", JSON.stringify(body));
    }

    public editOrganizationAccount(editOrganizationAccountForm: FormGroup, logoFiles: any, faviconFiles: any, splashScreenLogoFiles: any): Observable<any> {

        let body = new FormData();
        var imageFile = logoFiles[0];
        var faviconFile = faviconFiles[0];
        var splashScreenLogoFile = splashScreenLogoFiles[0];

        body.append("Id", editOrganizationAccountForm.controls.id.value);
        body.append("Name", editOrganizationAccountForm.controls.name.value);
        body.append("DisplayName", editOrganizationAccountForm.controls.displayName.value);
        body.append("ContactName", editOrganizationAccountForm.controls.contactName.value);
        body.append("ContactPhone", editOrganizationAccountForm.controls.contactPhone.value);
        body.append("ContactEmail", editOrganizationAccountForm.controls.contactEmail.value);
        // body.append("DomainName", editOrganizationAccountForm.controls.domainName.value);
        body.append("SupportEmail", editOrganizationAccountForm.controls.supportEmail.value);
        body.append("AddressLine1", editOrganizationAccountForm.controls.addressLine1.value);
        body.append("AddressLine2", editOrganizationAccountForm.controls.addressLine2.value);
        body.append("Town", editOrganizationAccountForm.controls.town.value);
        body.append("PostalCode", editOrganizationAccountForm.controls.postalCode.value);
        body.append("POBox", editOrganizationAccountForm.controls.poBox.value);
        body.append("Country", editOrganizationAccountForm.controls.country.value);
        body.append("Logo", imageFile);
        body.append("Favicon", faviconFile);
        body.append("SplashScreenLogo", splashScreenLogoFile);
        body.append("DevelopedBy", editOrganizationAccountForm.controls.developedBy.value);
        body.append("PrivacyPolicyLink", editOrganizationAccountForm.controls.privacyPolicyLink.value);
        body.append("TermsAndConditionsLink", editOrganizationAccountForm.controls.termsAndConditionsLink.value);
        body.append("SplashScreenLink", editOrganizationAccountForm.controls.splashScreenLink.value);
        body.append("DisplayCopyrights", editOrganizationAccountForm.controls.displayCopyrights.value);
        body.append("HeaderBackgroundColor", editOrganizationAccountForm.controls.headerBackgroundColor.value);
        body.append("LoginButtonBackgroundColor", editOrganizationAccountForm.controls.loginButtonBackgroundColor.value);
        return this.putForm("/administration/editOrganizationAccount", body);
    }


    public editAccount(editAccountForm: FormGroup, files: any): Observable<any> {
        var filesBase64 = null;

        if (files[0]) {
            filesBase64 = files[0].split(",").pop();
        }

        var body = {
            "Id": editAccountForm.controls.accountId.value,
            "Name": editAccountForm.controls.accountName.value,
            "DisplayName": editAccountForm.controls.displayName.value,
            "ContactName": editAccountForm.controls.contactName.value,
            "ContactPhone": editAccountForm.controls.contactPhone.value,
            "ContactEmail": editAccountForm.controls.contactEmail.value,
            "DomainName": editAccountForm.controls.domainName.value,
            "IsActive": editAccountForm.controls.isActive.value,
            "DocumentVerificationWithOCR": editAccountForm.controls.documentVerificationWithOCR.value,
            "DocumentCheckAnswerEmail": editAccountForm.controls.documentCheckAnswerEmail.value,
            "IdentityCheckAnswerEmail": editAccountForm.controls.identityCheckAnswerEmail.value,
            "StoreDocumentVerificationExports": editAccountForm.controls.storeDocumentVerificationExports.value,
            "StoreIdentityVerificationExports": editAccountForm.controls.storeIdentityVerificationExports.value,
            "AcurisMonitorSourceName": editAccountForm.controls.acurisMonitorSourceName.value,
            "EnabledLivenessDetectionClient": editAccountForm.controls.enabledLivenessDetectionClient.value,
            "Logo": filesBase64,
            "SendEmailNotification": editAccountForm.controls.sendEmailNotification.value,
            "ServiceTokenDepletionOrExpirationNotificationRecipients": editAccountForm.controls.serviceTokenDepletionOrExpirationNotificationRecipients.value,
            "NearDaysExpiration": editAccountForm.controls.daysBeforeExpiration.value ? editAccountForm.controls.daysBeforeExpiration.value : 10,
            "NearTokenDepletionPercentage": editAccountForm.controls.tokensThresholdPercentage.value ? editAccountForm.controls.tokensThresholdPercentage.value : 10,
            "Notes": editAccountForm.controls.notes.value,
            "AcurisTotalMonitoringBundle": editAccountForm.controls.acurisTotalMonitoringBundle.value,
        }

        return this.patchJson("/administration/editAccount", JSON.stringify(body));
    }

    public editUserDetails(email: string, isActive: boolean): Observable<any> {

        let body = {
            "email": email,
            "isActive": +isActive
        }

        return this.patchJson("/administration/editUserDetails", JSON.stringify(body));
    }

    public updateAccountServiceCosts(updateAccountServiceCostsForm: FormGroup): Observable<any> {

        let body = {
            "AccountId": updateAccountServiceCostsForm.controls.accountId.value,
            "Package": updateAccountServiceCostsForm.controls.package.value
        }

        return this.patchJson("/administration/updateAccountServiceCosts", JSON.stringify(body));
    }

    public updateAccountCommission(form: FormGroup): Observable<any> {

        let body = {
            "accountId": form.controls.accountId.value,
            "kompanyComCommissionPercentage": form.controls.commission.value
        }

        return this.patchJson("/administration/updateAccountCommission", JSON.stringify(body));
    }

    public editAccountServiceCost(body: any): Observable<any> {
        return this.putJson("/administration/editAccountServiceCost", JSON.stringify(body));
    }

    public editAccountPurchase(edittAccountPurchaseForm: FormGroup): Observable<any> {

        let body = {
            "Id": edittAccountPurchaseForm.controls.id.value,
            "StartDate": edittAccountPurchaseForm.controls.startDate.value,
            "EndDate": edittAccountPurchaseForm.controls.endDate.value,
        }

        return this.patchJson("/administration/editAccountPurchase", JSON.stringify(body));
    }

    public recoverAccountPurchase(recoverAccountForm: FormGroup): Observable<any> {

        let body = {
            "Id": recoverAccountForm.controls.id.value,
            "StartDate": recoverAccountForm.controls.startDate.value,
            "EndDate": recoverAccountForm.controls.endDate.value,
        }

        return this.patchJson("/administration/recoverAccountPurchase", JSON.stringify(body));
    }

    public addNotification(addNotificationForm: FormGroup, accounts: any) {
        let body = {
            "Icon": addNotificationForm.controls["notificationIconSelect"].value,
            "Message": addNotificationForm.controls["notificationMessage"].value,
            "NotificationTypeId": addNotificationForm.controls["notificationTypeSelect"].value,
            "ToAccounts": accounts.map((val) => {
                return {
                    name: val.accountName,
                };
            }),
        };
        return this.postJson("/administration/addNotification", JSON.stringify(body));
    }

    public removePersonsAcurisMonitoringLists(accounts: any) {

        let body = {
            "RemoveUniqueIds": Array.prototype.map.call(accounts, function (item) {
                return item.uniqueId
            }),
        };
        return this.postJson("/administration/removePersonsAcurisMonitoringLists", JSON.stringify(body));
    }

    public addUser(addUserForm: FormGroup): Observable<any> {

        let body = {
            "AccountId": addUserForm.controls.accountId.value,
            "Email": addUserForm.controls.email.value,
            "Password": addUserForm.controls.password.value,
            "Role": addUserForm.controls.role.value
        }

        return this.postJson("/administration/addUser", JSON.stringify(body));
    }

    public addServiceLicense(addServiceLicenseForm: FormGroup): Observable<any> {

        let body = {
            "accountName": addServiceLicenseForm.controls.accountName.value,
            "serviceId": addServiceLicenseForm.controls.serviceId.value,
            "licenseProductionStr": addServiceLicenseForm.controls.licenseProductionStr.value,
            "licenseDemoStr": addServiceLicenseForm.controls.licenseDemoStr.value,
            "chargeTokens": addServiceLicenseForm.controls.chargeTokens.value,
            "callProviderHealthCheckEndpoint": addServiceLicenseForm.controls.callProviderHealthCheckEndpoint.value,
            "ignoreFromHealthCheck": addServiceLicenseForm.controls.ignoreFromHealthCheck.value
        }

        return this.postJson("/administration/serviceLicenses", JSON.stringify(body));
    }

    public editServiceLicense(editServiceLicenseForm: FormGroup): Observable<any> {

        let body = {
            "id": editServiceLicenseForm.controls.id.value,
            "accountName": editServiceLicenseForm.controls.accountName.value,
            "serviceId": editServiceLicenseForm.controls.serviceId.value,
            "licenseProductionStr": editServiceLicenseForm.controls.licenseProductionStr.value,
            "licenseDemoStr": editServiceLicenseForm.controls.licenseDemoStr.value,
            "chargeTokens": editServiceLicenseForm.controls.chargeTokens.value,
            "callProviderHealthCheckEndpoint": editServiceLicenseForm.controls.callProviderHealthCheckEndpoint.value,
            "ignoreFromHealthCheck": editServiceLicenseForm.controls.ignoreFromHealthCheck.value
        }

        return this.putJson("/administration/serviceLicenses", JSON.stringify(body));
    }

    public addClient(addClientForm: FormGroup): Observable<any> {

        let body = {
            "AccountId": addClientForm.controls.accountId.value,
            "ClientId": addClientForm.controls.clientId.value,
            "DisplayName": addClientForm.controls.displayName.value
        }

        return this.postJson("/administration/addClient", JSON.stringify(body));
    }

    public addLivenessClient(clientId: any): Observable<any> {

        let body = {
            "clientId": clientId,
        }

        return this.postJson("/administration/addLivenessClient", JSON.stringify(body));
    }

    public addService(addServiceForm: FormGroup): Observable<any> {

        let body = {
            "AccountId": addServiceForm.controls.accountId.value,
            "ServiceTypeId": addServiceForm.controls.serviceTypeId.value,
            "serviceLicenseId": addServiceForm.controls.serviceLicenseId.value,
            "StartDate": addServiceForm.controls.startDate.value,
            "EndDate": addServiceForm.controls.endDate.value,
            "Credit": addServiceForm.controls.credit.value
        }

        return this.postJson("/administration/purchaseTokens", JSON.stringify(body));
    }

    public addStorage(addStorageForm: FormGroup): Observable<any> {
        let body = {
            "AccountId": addStorageForm.controls.accountId.value,
            "ContainerName": addStorageForm.controls.storageName.value
        }

        return this.postJson("/administration/createContainer", JSON.stringify(body));
    }

    public changePassword(settingsForm: FormGroup): Observable<any> {
        let body = {
            "CurrentPassword": settingsForm.controls.currentPassword.value,
            "NewPassword": settingsForm.controls.newPassword.value,
            "ConfirmPassword": settingsForm.controls.confirmPassword.value
        }

        return this.postJson("/user/changePassword", JSON.stringify(body));
    }

    public identityCheck(identityCheckForm: FormGroup): Observable<any> {
        var dobSendingToServer = new DatePipe('en-US').transform(identityCheckForm.controls.dob.value, 'MM/dd/yyyy');

        let body = {
            "AddressLine1": identityCheckForm.controls.addressLine1.value,
            "CountryCode": identityCheckForm.controls.countryCode.value,
            "CompleteName": identityCheckForm.controls.completeName.value,
            "Dob": dobSendingToServer,
            "AddressLine2": identityCheckForm.controls.addressLine2.value,
            "AddressLine3": identityCheckForm.controls.addressLine3.value,
            "District": identityCheckForm.controls.district.value,
            "HouseNumber": identityCheckForm.controls.houseNumber.value,
            "Locality": identityCheckForm.controls.locality.value,
            "PostalCode": identityCheckForm.controls.postalCode.value,
            "Province": identityCheckForm.controls.province.value,
            "Thoroughfare": identityCheckForm.controls.thoroughfare.value,
            "FullEmailAddress": identityCheckForm.controls.fullEmailAddress.value,
            "Gender": identityCheckForm.controls.gender.value,
            "NationalID": identityCheckForm.controls.nationalID.value,
            "OrganizationName": identityCheckForm.controls.organizationName.value,
            "PhoneNumber": identityCheckForm.controls.phoneNumber.value
        }

        return this.postJson("/v3/service/identityVerification", JSON.stringify(body));
    }

    public documentCheck(files, country): Observable<any> {

        var filesBase64 = files[0].split(",").pop();
        var files2Base64;

        if (files[1]) {
            var files2Base64 = files[1].split(",").pop();
            ;
        }
        let body = {
            "file": filesBase64,
            "fileSupport": files2Base64,
            "firstName": "-",
            "lastName": "-",
            "country": country,
            "documentType": "-"
        }

        return this.postForm("/v3/service/documentVerification", body);
    }

    public DocumentVerificationOnly(files): Observable<any> {

        var filesBase64 = files[0].split(",").pop();
        var files2Base64;

        if (files[1]) {
            var files2Base64 = files[1].split(",").pop();
            ;
        }
        let body = {
            "file": filesBase64,
            "fileSupport": files2Base64
        }

        return this.postForm("/v3/service/documentVerificationOnly", body);
    }

    public mrzCheck(files: any): Observable<any> {
        var filesBase64 = files[0].split(",").pop();
        let body = {

            "file": filesBase64,
            "fileSupport": null,
            "firstName": "-",
            "lastName": "-",
            "country": "-",
            "documentType": "-",
        }
        return this.postJson("/v3/service/mrzVerification", JSON.stringify(body));
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        // let errMsg = (error.error) ? error.error.message :
        //   error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(error); // log to console instead
        return throwError(error);
        //return Observable.throw(errMsg);
    }

    public personSearchRequestAdhoc(adhocPersonSearchForm: FormGroup): Observable<any> {
        let body = {
            "fullName": adhocPersonSearchForm.controls.fullName.value,
            "DateOfBirth": adhocPersonSearchForm.controls.dateOfBirth.value,
            "Address": adhocPersonSearchForm.controls.address.value,
            "City": adhocPersonSearchForm.controls.city.value,
            "Postcode": adhocPersonSearchForm.controls.postCode.value,
            "Country": adhocPersonSearchForm.controls.country.value,
            "Email": adhocPersonSearchForm.controls.email.value,
            "CompanyName": adhocPersonSearchForm.controls.companyName.value,
            "AcceptTermsAndCond": adhocPersonSearchForm.controls.acceptTermsAndCond.value,
            "VatCountry": adhocPersonSearchForm.controls.vatCountry.value,
            "VatNumber": adhocPersonSearchForm.controls.vatNumber.value
        }

        return this.postJson("/guest/PersonSearchRequestAdhoc", JSON.stringify(body));
    }

    public addEGOVResponse(clientDomainName, clientState, clientCode): Observable<any> {
        let body = {
            "clientDomainName": clientDomainName,
            "clientState": clientState,
            "clientCode": clientCode
        }

        return this.postJson("/guest/eGOVResponse", JSON.stringify(body));
    }

    public getCountriesAdhoc(): Observable<any> {
        return this.fetch("/guest/getCountries");
    }

    public getKompanyComGovernmentFees(): Observable<any> {
        return this.fetch("/kompanyCom/governmentFees");
    }

    public getKompanyCharges(): Observable<any> {
        return this.fetch("/kompanyCom/charges");
    }

    public getAccountKompanyCharges(accountId): Observable<any> {
        return this.fetch(`/kompanyCom/accounts/${accountId}/charges`);
    }

    public getAccountServiceCosts(): Observable<any> {
        return this.fetch("/administration/getAccountServiceCosts");
    }

    public getAccountServiceCostsPerAccount(accountId: any): Observable<any> {
        return this.fetch("/administration/" + accountId + "/getAccountServiceCostsPerAccount");
    }

    public getAdHocPaymentTransaction(orderId: any, paymentTransactionId: any): Observable<any> {

        let body = {
            "OrderId": orderId,
            "PaymentTransactionId": paymentTransactionId
        }

        return this.postJson("/guest/getAdHocPaymentTransaction", JSON.stringify(body));
    }

    public adHocSearch(orderId: any, paymentTransactionId: any): Observable<any> {

        let body = {
            "OrderId": orderId,
            "PaymentTransactionId": paymentTransactionId
        }

        return this.postJson("/guest/adHocSearch", JSON.stringify(body));
    }


    public checkValidVat(countryName: string, vatNumber: string): Observable<any> {
        let body = {
            "countryName": countryName,
            "vatNumber": vatNumber
        }

        return this.postJson("/guest/checkValidVat", JSON.stringify(body));
    }

    public deleteAccount(accountId: number): Observable<any> {
        return this.post("/administration/deleteAccount/" + accountId, {});
    }

    public permanentlyDeleteAccount(accountId: number): Observable<any> {
        return this.delete("/administration/permanentlyDeleteAccount/" + accountId, {});
    }

    public deleteServiceLicense(serviceLicenseId: number): Observable<any> {
        return this.delete("/administration/serviceLicenses/" + serviceLicenseId.toString(), {});
    }

    public getProposedValuesForCountryCategories(): Observable<any> {
        return this.fetch("/proposedvalues/proposedvaluesforcountrycategory");
    }

    public getProposedValuesForCountries(): Observable<any> {
        return this.fetch("/proposedvalues/proposedvaluesforcountries");
    }

    public getProposedValuesForDocuments(): Observable<any> {
        return this.fetch("/proposedvalues/proposedvaluesfordocuments");
    }

    public getProposedValuesCriteriaAndAnswers(): Observable<any> {
        return this.fetch("/proposedvalues/proposedvaluesforcriteriaandanswers");
    }

    public deleteCriterion(criterionId: any): Observable<any> {
        let body = {};
        return this.delete(`/administration/criterion/${criterionId}`, JSON.stringify(body));
    }

    public deleteDocument(documentId: any): Observable<any> {
        let body = {};
        return this.delete(`/administration/documents/${documentId}`, JSON.stringify(body));
    }

    public deleteCountryCategory(countryCategoryId: any): Observable<any> {
        let body = {};
        return this.delete(`/administration/countryCategories/${countryCategoryId}`, JSON.stringify(body));
    }

    public deleteCountry(countryName: string): Observable<any> {
        const encodedName = encodeURI(countryName);
        const url = `/administration/deletecountry/${encodedName}`;
        return this.delete(url, '{}');
    }

    public editCountries(model: any): Observable<any> {
        let body = model;
        return this.postJson("/administration/editcountries", JSON.stringify(body));
    }

    public editDocuments(model: any): Observable<any> {
        let body = model;
        return this.postJson("/administration/editdocuments", JSON.stringify(body));
    }

    public editCriteriaAndAnswers(model: any): Observable<any> {
        let body = model;
        return this.postJson("/administration/editcriteriaandanswers", JSON.stringify(body));
    }

    public addCountry(addCountryForm: FormGroup): Observable<any> {

        let body = {
            "name": addCountryForm.controls.name.value,
            "isoAlpha2Code": addCountryForm.controls.isoAlpha2Code.value,
            "isoAlpha3Code": addCountryForm.controls.isoAlpha3Code.value,
            "nationality": addCountryForm.controls.nationality.value,
            "evaluationGradeId": addCountryForm.controls.evaluationGradeId.value,
            "mappingReference": addCountryForm.controls.mappingReference.value,
        }
        return this.postJson("/administration/addcountry", JSON.stringify(body));
    }

    public addCountryCategory(addCountryCategoryForm: FormGroup): Observable<any> {

        let body = {
            "name": addCountryCategoryForm.controls.name.value,
        }
        return this.postJson("/administration/addcountrycategory", JSON.stringify(body));
    }


    public getCountryCategoryById(countryCategoryId: any): Observable<any> {
        return this.fetch("/administration/countrycategories/" + countryCategoryId.toString());
    }

    public editCountryCategory(editCountryCategory: FormGroup, countryCategoryCountries: any): Observable<any> {
        let body = {
            "id": editCountryCategory.controls.id.value,
            "name": editCountryCategory.controls.name.value,
            "countryCategoryCountries": countryCategoryCountries
        }
        return this.putJson("/administration/countryCategory", JSON.stringify(body));
    }

    public addCriterion(criterion: any): Observable<any> {

        let body = {
            "name": criterion.name,
            "riskPoint": criterion.riskPoint,
            "criteriaCategoryId": criterion.criteriaCategoryId,
            "status": criterion.status,
            "clientType": criterion.clientType,
            "regulationGroupId": criterion.regulationGroupId,
            "lastSyncDate": criterion.lastSyncDate,
            "syncReference": criterion.syncReference,
            "criterionAnswers": criterion.criterionAnswers
        }
        return this.postJson("/administration/addCriterion", JSON.stringify(body));
    }


    public getCriterionById(countryCategoryId: any): Observable<any> {
        return this.fetch("/administration/criteria/" + countryCategoryId.toString());
    }

    public editCriterion(criterion: any): Observable<any> {
        let body = {
            "id": criterion.id,
            "name": criterion.name,
            "riskPoint": criterion.riskPoint,
            "criteriaCategoryId": criterion.criteriaCategoryId,
            "status": criterion.status,
            "clientType": criterion.clientType,
            "regulationGroupId": criterion.regulationGroupId,
            "lastSyncDate": criterion.lastSyncDate,
            "syncReference": criterion.syncReference,
            "criterionAnswers": criterion.criterionAnswers
        }
        return this.putJson("/administration/criterion", JSON.stringify(body));
    }

    public addDocument(document: any): Observable<any> {
        let body = {
            "name": document.name,
            "clientType": document.clientType,
            "documentType": document.documentType,
            "mandatory": document.mandatory,
            "isVisibleToPortal": document.isVisibleToPortal,
            "status": document.status,
            "regulationGroupId": document.regulationGroupId,
            "lastSyncDate": document.lastSyncDate,
            "syncReference": document.syncReference
        }
        return this.postJson("/administration/addDocument", JSON.stringify(body));
    }


    public getDocumentById(countryCategoryId: any): Observable<any> {
        return this.fetch("/administration/document/" + countryCategoryId.toString());
    }

    public editDocument(document: any): Observable<any> {
        let body = {
            "id": document.id,
            "name": document.name,
            "clientType": document.clientType,
            "documentType": document.documentType,
            "mandatory": document.mandatory,
            "isVisibleToPortal": document.isVisibleToPortal,
            "status": document.status,
            "regulationGroupId": document.regulationGroupId,
            "lastSyncDate": document.lastSyncDate,
            "syncReference": document.syncReference
        }
        return this.putJson("/administration/document", JSON.stringify(body));
    }

    public getRegulationGroups(): Observable<any> {
        return this.fetch("/administration/regulationgroups");
    }

    public getEvaluationGrades(): Observable<any> {
        return this.fetch("/administration/evaluationgrades");
    }

    public getCriteriaCategories(): Observable<any> {
        return this.fetch("/administration/criteriacategories");
    }

    public getStatusEnum(): Observable<any> {
        return this.fetch("/administration/statusenum");
    }

    public getClientTypeEnum(): Observable<any> {
        return this.fetch("/administration/clienttypeenum");
    }

    public getDocumentTypeEnum(): Observable<any> {
        return this.fetch("/administration/documenttypeenum");
    }

}
